export const FETCH_PLAN_CNPJ_SERVICES_LIST = 'FETCH_PLAN_CNPJ_SERVICES_LIST'
export const FETCH_PLAN_CNPJ_SERVICES_LIST_FAILED = 'FETCH_PLAN_CNPJ_SERVICES_LIST_FAILED'
export const FETCH_PLAN_CNPJ_SERVICES_LIST_SUCCEEDED = 'FETCH_PLAN_CNPJ_SERVICES_LIST_SUCCEEDED'

export const fetchPlanServicesList = () => ({
  type: FETCH_PLAN_CNPJ_SERVICES_LIST,
})
